import { finishSpinner, startSpinner } from '../ui/spinner';

import ComunicacionConEmpresasService from "../../services/ComunicacionConEmpresasService";
import { types } from '../../types/types';
import { handleErrorApi } from '../../helpers/randoms';
import { startAlerta } from '../ui/alertas';
import { fetchConToken } from '../../helpers/fetch';
import { AREAS_USUARIOS } from '../../utils/constants';

export const setEstadoSolicitudComunicacionActual = (estado) => {
    return {
        type: types.updateEstadosSolicitudComunicacion,
        payload: estado
    }
}

export const limpiarDatosSuspensionEmpresa = () => {
    return {
        type: types.limpiarDatosSuspensionEmpresas
    }
}

export const seleccionarEmpresComunicacion = (empresa) => {
    return {
        type: types.seleccionarEmpresaComunicacion,
        payload: empresa
    }
}

export const LimpiarEmpresComunicacion = () => {
    return {
        type: types.desSeleccionarEmpresaComunicacion
    }
}

export const LimpiarObservacionesEmpresa = () =>{
    return{
        type: types.limpiarObservaciones
    }
}
export const BuscarSolicitud = (text) => (dispatch) => {
    dispatch({
        type: types.buscarSolicitudXUsuario,
        payload: text
    });
}
export const BuscarSolicitudPorAfi = (text) =>(dispatch) =>{
    dispatch({
        type: types.buscarSolicitudXUsuarioAfiliaciones,
        payload: text
    })
}
export const FiltrarPorEstadoSemaforo = (idEstado) => (dispatch) => {
    dispatch({
        type: types.filtrarPorEstadoSemaforo,
        payload: idEstado.toString()
    });
}

export const setFechaCargaDesde = (fecha) => (dispatch) =>{
    dispatch({
        type: types.fechaCargaDesdeComunicacion,
        payload: fecha
    })
}
export const setFechaCargaHasta = (fecha) => (dispatch) =>{
    dispatch({
        type: types.fechaCargaHastaComunicacion,
        payload: fecha
    })
}
export const setFechaUltimaModificacionDesde = (fecha) => (dispatch) =>{
    dispatch({
        type: types.fechaUltimaModificacionDesdeComunicacion,
        payload: fecha
    })
}
export const setFechaUltimaModificacionHasta = (fecha) => (dispatch) =>{
    dispatch({
        type: types.fechaUltimaModificacionHastaComunicacion,
        payload: fecha
    })
}
export const traerEstadosComunicacion = () => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.TraerEstadosComunicacion();
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerEstadosComunicacionSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerEstadosComunicacionError })
        handleErrorApi(dispatch, error, "Error al traer los estados de comunicacion", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const traerDatosSuspensionEmpresa = (cuit) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.TraerDatosSuspensionEmpresa(cuit);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerDatosSuspensionEmpresaSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerDatosSuspensionEmpresaError })
        handleErrorApi(dispatch, error, "Error al traer los datos de suspension de la empresa.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const traerDatosSuspensionAfiliados = (cuit) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.TraerDatosSuspensionAfiliados(cuit);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerDatosSuspensionAfiliadosSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerDatosSuspensionAfiliadosError })
        handleErrorApi(dispatch, error, "Error al traer los datos de suspension de los afiliados.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const suspenderCobertura = (cuit, estado, handleAfter) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.SuspenderCobertura(cuit, estado);
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta(`Se realizó la suspension de cobertura.`, 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            if (handleAfter)
                handleAfter()
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al suspender la cobertura.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const nuevaSolicitudComunicacion = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.NuevaSolicitudComunicacion(data);
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta(`Su solicitud de comunicacion fue enviada.`, 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(getSolicitudesComunicacion(data.IdEstado, null))
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al enviar la solicitud.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const getSolicitudesComunicacion = (idEstado, cuit, idAreaUsuario,
    fechaCargaDesde, fechaCargaHasta, fechaUltimaModificacionDesde, fechaUltimaModificacionHasta
) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.TraerSolicitudesComunicacion(idEstado, cuit, idAreaUsuario,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerSolicitudesComunicacionSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerSolicitudesComunicacionError })
        handleErrorApi(dispatch, error, "Error al cargar las solicitudes.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const nuevoMensajeComunicacion = (data, idEstado) => async (dispatch, getState) => {
    dispatch(startSpinner());
    try {
        const {fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta} = getState().comunicacionEmpresas
        const response = await ComunicacionConEmpresasService.NuevoMensajeComunicacion(data);
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta(`Su mensaje fue enviado.`, 'success', 'Comando Exitoso'));
            dispatch(getSolicitudesComunicacion(idEstado, null, data.idOrigen,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta));
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al enviar el mensaje.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const getMensajesComunicacion = (idBandejaSuspension) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.TraerMensajesComunicacion(idBandejaSuspension);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerMensajesComunicacionSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerMensajesComunicacionError })
        handleErrorApi(dispatch, error, "Error al traer los mensajes.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const cerrarComunicacion = (cuit, mensaje, idEstado, areaUsuario, handleAfter) => async (dispatch,getState) => {
    dispatch(startSpinner());
    try {
        const {fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta} = getState().comunicacionEmpresas
        const response = await ComunicacionConEmpresasService.CerrarCasoComunicacion(cuit, mensaje);
        const body = await response.json();
        if (response.ok) {
            handleAfter()
            dispatch(startAlerta(`El caso fue cerrado.`, 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(getSolicitudesComunicacion(idEstado, null, areaUsuario,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta))
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al cerrar el caso.", "Ha ocurrido un error. Intente nuevamente")
    }
}



export const getObservacionesEmpresa = (cuit) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.TraerObservacionesEmpresa(cuit);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerObservacionesEmpresaSuccess,
                payload: body
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerMensajesComunicacionError })
        handleErrorApi(dispatch, error, "Error al traer las observaciones.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const NuevaObservacionEmpresa = (data) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComunicacionConEmpresasService.NuevaObservacionEmpresa(data);
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta(`Su observacion fue enviada.`, 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(getObservacionesEmpresa(data.Cuit));
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al enviar la observacion.", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const fetchEmpresaXCUITComunicacion = (CUIT) => {
    return async (dispatch, getState) => {
        dispatch(startSpinner());
        const response = await fetchConToken(`empresas/traerPorCUIT/${CUIT}`);
        if (!response.ok) {
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length > 0) {
                dispatch({
                    type: types.seleccionarEmpresaComunicacion,
                    payload: (lista[0])
                });
                //return lista[0];
                const { empresaSeleccionada } = getState().comunicacionEmpresas;
                dispatch(finishSpinner());
                return empresaSeleccionada;
                //console.log('empresa retorno',empresa);
            }
        }
        dispatch(finishSpinner());
    };
};

export const generateExcel = (idBandeja) => async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await ComunicacionConEmpresasService.GenerarExcel(idBandeja)
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
        let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download =  `Caso-SuspensionCobertura.xlsx` 
        a.click();
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el excel",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }

  export const marcarLeidoCasoSuspension = (idBandeja,idAreaUsuario, desmarcar) => async (dispatch,getState) => {
    dispatch(startSpinner());
    try {
        const {fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta} = getState().comunicacionEmpresas
      const response = await ComunicacionConEmpresasService.MarcarLeidoCasoSuspension(idBandeja,idAreaUsuario)
      const { estadoComunicacionActual } = getState().comunicacionEmpresas;
      const body = await response.json();
      if (response.ok) {
        if(desmarcar){
            dispatch(getSolicitudesComunicacion(estadoComunicacionActual,null,idAreaUsuario,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta));
        }
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al marcar la conversacion como leida.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }

  
  export const cambiarEstadoSemaforo = (idBandeja,estado, areaUsuario) => async (dispatch,getState) => {
    dispatch(startSpinner());
    try {
        const data={
            IdBandeja: idBandeja,
            Estado: estado
        }
      const response = await ComunicacionConEmpresasService.CambiarEstadoSemaforo(data);
      const { estadoComunicacionActual,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta } = getState().comunicacionEmpresas;
      const body = await response.json();
      if (response.ok) {
        dispatch(getSolicitudesComunicacion(estadoComunicacionActual,null,areaUsuario ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta));
        dispatch(finishSpinner());
        dispatch(startAlerta(`Estado modificado correctamente.`, 'success', 'Comando Exitoso'));
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al cambiar el estado.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  }

  export const changeEstadoSeguimiento = (idBandeja, seguimiento,areaUsuario) => {
    return async (dispatch,getState) => {
        try {
            dispatch(startSpinner());
            const { estadoComunicacionActual,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta } = getState().comunicacionEmpresas;
            const response = await fetchConToken(`SuspensionCobertura/MarcarSeguimiento/${idBandeja}/${seguimiento}`,{},"PUT");
            if(response.ok){
                dispatch(getSolicitudesComunicacion(estadoComunicacionActual,null,areaUsuario ? AREAS_USUARIOS.NACIONAL : AREAS_USUARIOS.MESA_DE_AYUDA,fechaCargaDesde,fechaCargaHasta,fechaUltimaModificacionDesde,fechaUltimaModificacionHasta));
                dispatch(startAlerta(`Solicitud actualizada.`, 'success', 'Comando Exitoso'));
            }
            dispatch(getSolicitudesComunicacion)
            dispatch(finishSpinner());
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
              dispatch,
              error,
              "Error al actualizar la solicitud.",
              "Ha ocurrido un error. Intente nuevamente"
            );
          }

    };
};
